import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleResetSearchList } from "./savedSearches";
export const getLeadByIdAPI = createAsyncThunk(
  "leads/getLeadByIdAPI",
  async (data, thunkAPI) => {
    thunkAPI.dispatch(handleResetSearchList());
    try {
      let headers = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
          "Content-Type": "application/json",
        },
      };
      if (data.params) {
        headers["params"] = data.params;
      }
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/leads/people/${data.id}?fields=allFields`,
        headers
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
